import script from "./ParameterTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./ParameterTable.vue?vue&type=script&setup=true&lang=ts"

import "./ParameterTable.vue?vue&type=style&index=0&id=0fec01c2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\t.matsutake\\workspace\\vue_ws\\EISStudio\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fec01c2"]])

export default __exports__